//for wishlist drawer
var wishlistDrawer = document.querySelector('.wishlist-drawer');

function swymCallbackFn() {
    if (wishlistDrawer) {
        _swat.fetchWrtEventTypeET(getAllWishlistDrawer, 4);
    }
    _swat.fetchWrtEventTypeET(function (products) {
        products.forEach(function (item) {
            setBtnState(item.epi, true);
        });
    });
    if ($('.template-product').length) {
        $('form[action="/cart/add"]')
            .find('.select-options')
            .on('change', function () {
                setTimeout(function () {
                    _swat.fetchWrtEventTypeET(function (products) {
                        $.each(products, function (index, item) {
                            if (item.epi == $('.wishlist-btn').attr('data-swym-epi')) {
                                setBtnState(item.epi, true);
                                return false;
                            } else {
                                $('.wishlist-btn').removeClass('in-wishlist');
                            }
                        });
                    });
                }, 500);
            });
    }
}

if (!window.SwymCallbacks) {
    window.SwymCallbacks = [];
}
window.SwymCallbacks.push(swymCallbackFn);

function getAllWishlistDrawer(products) {
    products.map((pd) => {
        buildWishlistItem(pd, pd.epi, pd.pr, pd.iu);
    });
    getWishlistCount();
}

function getWishlistCount() {
    _swat.wishlistCount(function (item) {
        if (item == 0) {
            $('body').addClass('empty-wishlist');
        } else {
            $('body').removeClass('empty-wishlist');
        }
        $('.wishlist-drawer .wishlist-count').html(`(${item})`);
    });
}

function buildWishlistItem(product, variant_id, price, original_image) {
    const params = {
        epi: product.epi,
        empi: product.empi,
        du: product.du
    };
    var itemRowHtml = '';
    _swat.getProductDetails(params, (productJSON) => {
        var item_obj = productJSON;
        var itemPrice = parseFloat(price)
            .toFixed(2)
            .replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,');
        itemRowHtml += `<div class="drawer-row-item" data-productid="${item_obj.id}" data-price="${price}" data-iu="${original_image}" data-epi="${variant_id}">
		<div class="grid-item grid-thumb">
				<div class="product-thumbnail">
					<div class="product-image align-middle" style="background: url(${item_obj.featured_image}) no-repeat top center / contain">
							<a href="${item_obj.url}?variant=${variant_id}"></a>
					</div>
				</div>
		</div>
		<div class="grid-item grid-desc grid-x align-middle">
			<div class="product-details product-description position-relative">
					<div>
						<h6 class="text-uppercase">${item_obj.vendor}</h6>
						<p><a href="${item_obj.url}?variant=${variant_id}" class="not-underline">${item_obj.title}</a></p>`;
        $.each(item_obj.variants, function (index, variant) {
            if (variant.id == variant_id) {
                itemRowHtml += `<p class="small"><span class="variant_title">${variant.title}</span></p>`;
            }
        });
        if (item_obj.available) {
            itemRowHtml += `<button class="add-cart-wishlist-item btn btn-secondary dark">Add To Cart</button>`;
        } else {
            itemRowHtml += `<button class="add-cart-wishlist-item btn btn-secondary dark" disabled="disabled">Out of Stock</button>`;
        }
        itemRowHtml += `</div> 
			</div>
		</div>
		<div class="grid-item grid-price-remove">
				<span class="btn-remove-wishlist pointer">&#x2715;</span>
				<div class="item-total">$${itemPrice}</div>
		</div>
	</div>`;
        $('.wishlist-drawer .cart-items').prepend(itemRowHtml);
    });
}

function setBtnState(epi, setActive) {
    var $btn = $('.wishlist-btn[data-swym-epi="' + epi + '"]');
    $btn.toggleClass('in-wishlist', setActive);
}

$(document).on('click', '.add-cart-wishlist-item', function () {
    const removeBtn = $(this).closest('.grid-desc').parent().find('.grid-price-remove .btn-remove-wishlist');
    var var_id = $(this).closest('.grid-desc').parent().data('epi');
    var quantity = 1;
    var data = {
        quantity: quantity,
        id: var_id
    };

    $.ajax({
        type: 'post',
        url: '/cart/add.js',
        data,
        dataType: 'json',
        success(data) {
            Shopify.getCart(function (cart) {
                window.cartUpdater.updateCartItem();
                $('.close-wishlist').click();
                $('.cart-drawer .cart-native--cross-sell').removeClass('d-none');
                $('.cart-drawer .cart-footer .btn').removeClass('disabled');
                $('body').addClass('slide-cart');
                $('html').css('overflow', 'hidden');
                $('body').removeClass('empty-cart');
                setTimeout(function () {
                    removeBtn.click();
                }, 200);
                setTimeout(function () {
                    $('body').removeClass('slide-cart');
                    $('html').removeAttr('style');
                }, 5000);
                window.updateCartDrawer.updateCartTotal();
            });
        },
        error(res) {
            // console.log(res)
            alert('There was an error adding your product to cart. Please lower the quantity and try again.');
        }
    });
});

$(document).on('click', '.btn-remove-wishlist', function () {
    var btn = $(this);
    var parent = btn.closest('.grid-price-remove').parent();
    var data = {
        epi: parseInt(parent.data('epi')),
        empi: parseInt(parent.data('productid')),
        pr: parseFloat(parent.data('price')),
        iu: `${parent.data('iu')}`
    };

    _swat.removeFromWishList(data, function (res) {
        $('.wishlist-drawer .cart-items').html('');
        setBtnState(res.epi, false);
        _swat.fetchWrtEventTypeET(getAllWishlistDrawer, 4);
    });
});

$(document).on('click', '.wishlist-btn', function (e) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        event: 'uxTracking',
        siteComponent: 'Collection Page',
        componentLabel: 'Wishlist Button'
    });
    var $btn = $(e.currentTarget);
    var epi = $btn.attr('data-swym-epi');
    var empi = $btn.data('swym-empi');
    var du = $btn.data('swym-du');
    var dt = $btn.data('swym-dt');
    var iu = $btn.data('swym-iu');
    var pr = parseFloat($btn.attr('data-swym-pr'));
    if ($btn.hasClass('in-wishlist')) {
        window._swat.removeFromWishList(
            {
                epi: epi,
                empi: empi,
                du: du,
                dt: dt,
                iu: iu,
                pr: pr
            },
            function (res) {
                setBtnState(res.epi, false);
            }
        );
    } else {
        window._swat.addToWishList({ epi, empi, du, dt, iu, pr }, function (res) {
            setBtnState(res.epi, true);
        });
    }
    setTimeout(function () {
        $('.wishlist-drawer .cart-items').html('');
        _swat.fetch(function (products) {
            products.map((pd) => {
                buildWishlistItem(pd, pd.epi, pd.pr, pd.iu);
            });
        });
        getWishlistCount();
    }, 300);
});

$(document).on('click', '.remove-all-btn', function (e) {
    e.preventDefault();
    const btn = $(this);
    const parentContainer = btn.closest('.cart-footer').parent().find('.wishlist-items');
    const wishlists = parentContainer.find('.drawer-row-item');
    wishlists.map(function (index, wishlist) {
        $(wishlist).find('.grid-price-remove .btn-remove-wishlist').click();
    });
});

function getCompleteProductDetails(wishlistedProducts, callback) {
    const entireProducts = [];
    if (wishlistedProducts) {
        wishlistedProducts.forEach((product, currentIndex, wishlist) => {
            const params = {
                epi: product.epi,
                empi: product.empi,
                du: product.du
            };
            _swat.getProductDetails(params, (productJSON) => {
                entireProducts.push(productJSON);
                if (currentIndex == wishlist.length - 1) {
                    callback(entireProducts); // contains entire product items in your wishlist.
                }
            });
        });
    }
}
